const userProfile = { data: [], loading: true };
const personalProfile = { data: [], loading: true };

export const GetBusinessProfile = (state = userProfile, action) => {
  switch (action.type) {
    case "get_businessprofile":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetPersonalProfile = (state = personalProfile, action) => {
  switch (action.type) {
    case "get_personalprofile":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
